/**
 * @flow
 * @relayHash 8e99eeef71d627c38fa187f73ae6fd99
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchResultsContainer_viewer$ref = any;
export type SearchResultsQuery_UserEvent_Pagination_QueryVariables = {|
  count: number,
  query: string,
  cursor?: ?string,
|};
export type SearchResultsQuery_UserEvent_Pagination_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SearchResultsContainer_viewer$ref
  |}
|};
export type SearchResultsQuery_UserEvent_Pagination_Query = {|
  variables: SearchResultsQuery_UserEvent_Pagination_QueryVariables,
  response: SearchResultsQuery_UserEvent_Pagination_QueryResponse,
|};
*/


/*
query SearchResultsQuery_UserEvent_Pagination_Query(
  $count: Int!
  $query: String!
  $cursor: String
) {
  viewer {
    ...SearchResultsContainer_viewer_1jWD3d
    id
  }
}

fragment SearchResultsContainer_viewer_1jWD3d on User {
  s_time_zone
  user_event_search(first: $count, after: $cursor, query: $query) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchResultsQuery_UserEvent_Pagination_Query",
  "id": null,
  "text": "query SearchResultsQuery_UserEvent_Pagination_Query(\n  $count: Int!\n  $query: String!\n  $cursor: String\n) {\n  viewer {\n    ...SearchResultsContainer_viewer_1jWD3d\n    id\n  }\n}\n\nfragment SearchResultsContainer_viewer_1jWD3d on User {\n  s_time_zone\n  user_event_search(first: $count, after: $cursor, query: $query) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchResultsQuery_UserEvent_Pagination_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchResultsContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchResultsQuery_UserEvent_Pagination_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_search",
            "storageKey": null,
            "args": v1,
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "booking_status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "start_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "end_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:1)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "location",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v2
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_event_search",
            "args": v1,
            "handle": "connection",
            "key": "SearchResultsContainer_user_event_search",
            "filters": [
              "query"
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5a3db88de880799eb9cf85083e9a77b8';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/SearchResultsQuery_UserEvent_Pagination_Query.graphql.js